import '../css/wa.css';
import '../css/monthly.css';
import React from "react";

function Monthly() {
    return (
        <>
            <div className='mt-center'>
                <div className='mt-main'>
                    <h2>익스퍼트 안내</h2>
                    <p className="mt-description">
                        본인이 전력 분야 전문가인 경우, 익스퍼트로 등록해 활동하세요. 익스퍼트 신청 폼에서 전문가임을 입증할 수 있는 사유를 작성하거나 oljh.9@kakao.com으로 직접 문의할 수 있습니다.
                    </p>
                    
                    <div className="mt-service">
                        <h2>익스퍼트가 되면</h2>
                        <ul className="service-list">
                            <li><span className="icon">💬</span> 글과 프로필 표기</li>
                            <li><span className="icon">🗣️</span> 익스퍼트 글로 추천</li>
                            <li><span className="icon">📚</span> 기타 정보 접근 등</li>
                        </ul>
                    </div>

                    <div className='mt-btn'>
                        <button className='btn-expert' onClick={() => window.location.href = `/form?type=expert`}>익스퍼트 신청하기</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Monthly;
